import React, { useEffect, useRef, useState } from "react";
import themeStyles from "../../../shared/styles/theme/theme-styles.module.scss";
import styles from "./styles.module.scss";
import loadingImg from "../../../shared/images/loading1.svg";

const UploadImage = (props) => {
  const { loadingImage } = props;
  const inputRef = useRef(null);
  const [imageUrl, setImageUrl] = useState(props.image);

  useEffect(() => {
    setImageUrl(props.image);
  }, [props.image]);

  const handleImage = (e) => {
    inputRef.current.click();
  };
  const handleChangeImage = (e) => {
    if (e.target.files.length) {
      props.uploadImage(e.target.files[0]);
    }
  };

  return (
    <div className={styles.containerInput}>
      <div style={{ display: "flex", flex: "auto" }}>
        <div className={styles.containerImg} onClick={handleImage}>
          {loadingImage ? (
            <img src={loadingImg} alt="" width="100%" height="137px"></img>
          ) : imageUrl ? (
            <img src={imageUrl} alt="" width="100%" height="50px"></img>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <span>
                <i
                  className={themeStyles.iconPicture}
                  style={{ fontSize: "2rem" }}
                />
              </span>
            </div>
          )}
          <input
            type="file"
            style={{ display: "none" }}
            accept=".jpg"
            ref={inputRef}
            onChange={handleChangeImage}
          />
        </div>
      </div>
    </div>
  );
};

export default UploadImage;
